import { SNIPPET_ANCHOR_SKIP_WORDS } from '../academySearch.const'

const SNIPPET_ANCHOR_SKIP = new Set<string>(SNIPPET_ANCHOR_SKIP_WORDS)

export function buildSnippetAnchorTerms(queryTerms: string[]): string[] {
  const meaningful = queryTerms.filter((term) => term.length >= 2 && !SNIPPET_ANCHOR_SKIP.has(term))
  const pool = meaningful.length > 0 ? meaningful : queryTerms.filter((term) => term.length > 0)
  return [...pool].sort((a, b) => b.length - a.length)
}
